<template>

    <div class="ref_box_container" :class="{inDrag: inDrag}" :draggable="isDraggable" @dragstart="onDragStart($event, refItem)" @dragend="onDragEnd($event, refItem)" >

        <refBox class="ref_box" :pose="containerIsVisible ? 'visible' : 'hidden'">
            <div class="ref_box_icon"><IconRef /></div>
            <div class="ref_box_name">{{ refItem.name }}</div>
            <div v-if="notOwnedRef" class="ref_box_rec_name">{{ refItem.recruiter_name }}</div>

            <!-- <br>{{ refItem.sight_ref_cat_id }} -->

            <div class="ref_box_actions">
                <div class="edit_ref" @click="goEdit" v-if="canEditRef"><i class="icon-pencil"></i></div>
                <div class="edit_ref" @click="goEdit" v-else><i class="icon-eye"></i></div>


                <div class="duplicate_ref" @click="duplicateRef" v-if="canEditRef"><i class="icon-docs"></i></div>
                <div class="delete_ref" @click="openDeleteAlert" v-if="canEditRef"><i class="icon-close"></i></div>
            </div>

            <div class="delete_confirm" :class="{active: inDelete}">
                <span>{{ $t('modules.refs.index.refsList.deleteRefNotice') }}</span>
                <button @click="deleteRef" class="button is-danger">{{ $t('modules.refs.index.refsList.deleteRefConfirmButton') }}</button>
                <button @click="cancelDeleteAlert" class="button is-inverse">{{ $t('modules.refs.index.refsList.deleteRefCancelButton') }}</button>
            </div>
        </refBox>

    </div>
</template>

<script>
import posed from 'vue-pose';
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'RefListItem',
    props: ['refItem'],
    components: {
        refBox: posed.div({
            visible: {
                opacity: 1,
                scale: 1
            },
            hidden: {
                opacity: 0,
                scale: 0
            },
            hoverable: true,
            init: { scale: 1 },
            hover: { scale: 1.01 }
        })
    },
    mounted(){
        setTimeout(() => {
            this.containerIsVisible = true;
        }, 100 );
    },
    data(){
        return {
            inDrag: false,
            containerIsVisible: false,
            inDelete: false,
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },

    computed: {
        notOwnedRef(){
            return this.userData.id != this.refItem.user_id
        },
        shareModeActive(){
            return JSON.parse(localStorage.getItem('account')).contract.sharing_data_mode == "across_company"
        },
        canEditRef(){
            return !this.notOwnedRef || this.shareModeActive
        },
        isDraggable(){
            return this.canEditRef
        }
    },
    methods: {
        openDeleteAlert(){
            this.inDelete = true
        },
        cancelDeleteAlert(){
            this.inDelete = false
        },
        deleteRef(){
            this.$store.dispatch('RefStore/deleteRef', this.refItem).then(() => {
                this.$store.dispatch('RefStore/CustomRefsList', {})
                this.inDelete = false
            })
        },
        duplicateRef(){
            if( userCanAccess('features', 'create_sight_ref') ){
                this.$store.dispatch('RefStore/duplicateRef', this.refItem).then(() => {
                    this.$store.dispatch('RefStore/CustomRefsList', {})
                })
            }else{
                this.$router.push('/unautorized'); 
            }
        },
        goEdit(){
            this.$router.push('/refs/' + this.refItem.id)
        },
        onDragStart(event, refItem){
            this.inDrag = true
            this.$emit('dragstart', event, refItem)
        },
        onDragEnd(event, refItem){
            this.inDrag = false
            this.$emit('dragend', event, refItem)
        }
    }
}
</script>

<style lang="scss">

    .ref_box_container{
        width: 200px;
        padding: 20px;
        transition: .3s all;
        &:hover{
            transform: scale(1.1);
        }
        &.inDrag{
            .ref_box{
                box-shadow: 0 0 10px $primary;
            }
        }
        .ref_box{
            height: 200px;
            background: $white;
            padding: 20px;
            text-align: center;
            border-radius: 10px;
            box-shadow: 2px 2px 6px $grey-light;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .ref_box_icon{
                text-align: center;
                width: 100px;
                svg{
                    fill: $grey-light;
                    width: 38px;
                    height: 38px;
                }
            }
            .ref_box_name{
                flex: 1;
                font-weight: 500;;
            }
            .ref_box_rec_name{
                font-style: italic;
                font-weight: 500;
                color: #b5b5b5;
                color: $primary;
            }
            .ref_box_actions{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-around;
                & div{
                    width: 32px;
                    height: 32px;
                    line-height: 34px;
                    border-radius: 100%;
                    transition: .3s all;
                    cursor: pointer;
                    &:hover{
                        background: $info;
                        color: $white;
                    }
                }
            }
            .delete_confirm{

                display: flex;
                position:absolute;
                top:0;
                bottom:0;
                left:0;
                right:0;
                background-color: $info;
                color: white;
                flex-direction: column;
                padding: 8px;
                justify-content: space-between;
                transition: .3s all;
                transform: scale(0);
                &.active{
                    height: auto;
                    transform: scale(1);
                }
            }
        }
    }

</style>